import {
  CONTACT_ADDRESS_ADDRESS1,
  CONTACT_ADDRESS_ADDRESS2,
  CONTACT_ADDRESS_CITY,
  CONTACT_ADDRESS_COUNTRY_CODE,
  CONTACT_ADDRESS_POSTAL_CODE,
  CONTACT_ADDRESS_REGION_CODE,
  CONTACT_LANGUAGE_CODE,
  CONTACT_TIMEZONE,
  type IAddressData,
} from "src/shared/contacts/forms/inputs/address/IAddressData";
import type ContactClass from "src/shared/contacts/objects/Contact";

export const CONTACT_CONTACT_FIRST_NAME = "contactFirstName";
export const CONTACT_CONTACT_LAST_NAME = "contactLastName";
export const CONTACT_CONTACT_TITLE = "contactTitle";
export const CONTACT_CONTACT_EMAIL = "email";
export const CONTACT_CONTACT_PHONE_NUMBER = "phoneNumber1";
export const CONTACT_CONTACT_PHONE_EXT = "phoneExt1";
export const CONTACT_CONTACT_MOBILE_NUMBER = "mobileNumber";

export interface IContactData extends IAddressData {
  [CONTACT_CONTACT_FIRST_NAME]?: string;
  [CONTACT_CONTACT_LAST_NAME]?: string;
  [CONTACT_CONTACT_TITLE]?: string;
  [CONTACT_CONTACT_EMAIL]?: string;
  [CONTACT_CONTACT_PHONE_NUMBER]?: string;
  [CONTACT_CONTACT_PHONE_EXT]?: string;
  [CONTACT_CONTACT_MOBILE_NUMBER]?: string;
}

export function AddIContactDataToContact(
  formData: IContactData,
  contact: ContactClass,
): void {
  contact.address1 = formData[CONTACT_ADDRESS_ADDRESS1];
  contact.address2 = formData[CONTACT_ADDRESS_ADDRESS2];
  contact.city = formData[CONTACT_ADDRESS_CITY];
  contact.regionCode = formData[CONTACT_ADDRESS_REGION_CODE];
  contact.countryCode = formData[CONTACT_ADDRESS_COUNTRY_CODE];
  contact.postalCode = formData[CONTACT_ADDRESS_POSTAL_CODE];
  contact.languageCode = formData[CONTACT_LANGUAGE_CODE];
  contact.timeZone = formData[CONTACT_TIMEZONE];
  contact.contactFirstName = formData[CONTACT_CONTACT_FIRST_NAME];
  contact.contactLastName = formData[CONTACT_CONTACT_LAST_NAME];
  contact.contactTitle = formData[CONTACT_CONTACT_TITLE];
  contact.email = formData[CONTACT_CONTACT_EMAIL];
  contact.phoneNumber1 = formData[CONTACT_CONTACT_PHONE_NUMBER];
  contact.phoneExt1 = formData[CONTACT_CONTACT_PHONE_EXT];
  contact.mobileNumber = formData[CONTACT_CONTACT_MOBILE_NUMBER];
}

export function ContactToIContactData(
  contact: ContactClass,
): Partial<IContactData> {
  return {
    [CONTACT_ADDRESS_ADDRESS1]: contact.address1,
    [CONTACT_ADDRESS_ADDRESS2]: contact.address2,
    [CONTACT_ADDRESS_CITY]: contact.city,
    [CONTACT_ADDRESS_REGION_CODE]: contact.regionCode,
    [CONTACT_ADDRESS_COUNTRY_CODE]: contact.countryCode,
    [CONTACT_ADDRESS_POSTAL_CODE]: contact.postalCode,
    [CONTACT_LANGUAGE_CODE]: contact.languageCode,
    [CONTACT_TIMEZONE]: contact.timeZone,
    [CONTACT_CONTACT_FIRST_NAME]: contact.contactFirstName,
    [CONTACT_CONTACT_LAST_NAME]: contact.contactLastName,
    [CONTACT_CONTACT_TITLE]: contact.contactTitle,
    [CONTACT_CONTACT_EMAIL]: contact.email,
    [CONTACT_CONTACT_PHONE_NUMBER]: contact.phoneNumber1,
    [CONTACT_CONTACT_PHONE_EXT]: contact.phoneExt1,
    [CONTACT_CONTACT_MOBILE_NUMBER]: contact.mobileNumber,
  };
}

/**
 * @deprecated
 */
export default IContactData;
